import React, { useEffect, useState } from "react";

import "../Main.css";
import { TextField, Button } from "@mui/material";
import { HOST_URL } from "../common";

const ChangePW = () => {
  useEffect(() => {}, []);

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [reNewPassword, setReNewPassword] = useState("");

  const handleSave = () => {
    console.log("here");

    if (newPassword !== reNewPassword) {
      window.alert("패스워드가 다릅니다.");
    } else {
      //const url = 'http://30.30.30.3:3002/changepw';
      const url = HOST_URL + ":3002/changepw";
      const postBody = { currentpw: currentPassword, newpw: newPassword };

      console.log("request data : ", JSON.stringify(postBody));

      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(postBody),
        credentials: "include",
      })
        .then((res) => res.json())
        .then((result) => {
          if (result.code === "ok") {
            window.location.href = "/";
          } else if (result.code === "error") {
            window.alert(result.reason);
          }
        });
    }
  };

  return (
    <div className="Main-container">
      <div>
        <h2>KSIC 개발자 포털 [ 비밀번호변경 ]</h2>
        <h6>Please change your secret key code</h6>

        <div style={{ display: "flex", flexDirection: "column", padding: 10 }}>
          <TextField
            id="filled-basic"
            label="Current password"
            variant="filled"
            style={{
              margin: 5,
              backgroundColor: "white",
            }}
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            type="password"
          />

          <TextField
            id="filled-basic"
            label="New password"
            variant="filled"
            style={{ margin: 5, backgroundColor: "white" }}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            type="password"
          />

          <TextField
            id="filled-basic"
            label="Re new password"
            variant="filled"
            style={{
              margin: 5,
              backgroundColor: "white",
            }}
            value={reNewPassword}
            onChange={(e) => setReNewPassword(e.target.value)}
            type="password"
          />

          <Button
            variant="contained"
            style={{ margin: 10 }}
            onClick={handleSave}
          >
            저장
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ChangePW;
